export default "__VITE_ASSET__b9bff1d6__"